export default {"src":"/_next/static/media/cc-paypal-logo.1e29a2eb.svg","height":23,"width":32,"blurWidth":0,"blurHeight":0};